import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "./Footer";
import { LEGAL_DOCS } from "../legalContent";

export default function LegalPage() {
  const { doc } = useParams();
  const navigate = useNavigate();
  const data = LEGAL_DOCS[doc];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [doc]);

  useEffect(() => {
    if (!data) navigate("/404", { replace: true });
  }, [data, navigate]);

  if (!data) return null;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header bar */}
      <header className="border-b border-slate-100 sticky top-0 bg-white z-30">
        <div className="container mx-auto px-4 max-w-[1200px] flex items-center justify-between py-4">
          <Link to="/" className="flex items-center">
            <img src="/intelisoft-logo.png" alt="InteliSoft.ai" className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-[#1b6ef3] transition-colors"
          >
            <ArrowLeft size={16} /> Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="container mx-auto px-4 max-w-[860px] py-16">
          <h1 className="text-4xl font-bold mb-2" style={{ color: "#141b34" }}>
            {data.title}
          </h1>
          <p className="text-sm text-slate-400 mb-10">Stand: {data.updated}</p>

          <div className="space-y-9">
            {data.sections.map((s, i) => (
              <section key={i}>
                <h2 className="text-xl font-semibold mb-3" style={{ color: "#141b34" }}>
                  {s.heading}
                </h2>
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="text-[15px] leading-relaxed text-slate-600 mb-2">
                    {p}
                  </p>
                ))}
              </section>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
